export default __webpack_public_path__ + "static/media/pine-tree.ae71bb0e.png";